var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-lg-10 col-lg-offset-1"},[_c('div',{staticClass:"hpanel"},[_c('calendar')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }